/* eslint-disable no-undef */
import React, { useRef, useState, useEffect } from "react";
import { Typography, Avatar } from "@mui/material";
import { Person, PriorityHigh } from "@mui/icons-material";
import withStyles from "@mui/styles/withStyles";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";

import AddGroupAvatar from "../../../../assets/icons/GroupAvatar";
import { showFileUploadAction } from "../../../../redux/users/actions";
import customImageInputStyle from "./style.js";
import Loader from "../../../../components/shared/SuspenseFallback";

import axios from "axios";

const CustomImageInput = ({
  errorMessage,
  classes,
  avatarURL,
  setFieldValue,
  field,
  isCreateGroup,
  isGroupInfo,
}) => {
  const [file, setFile] = useState(undefined);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(undefined);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const fileUpload = useRef();
  const imageRef = useRef();
  const dispatch = useDispatch();
  const {
    showFileUpload: showFile,
    userInfo: { token },
  } = useSelector((state) => state.user);

  const avatarStyle = classnames(
    classes.bigAvatar,
    file ? [classes.whiteBack] : [classes.primaryBack],
    { [classes.errorBack]: errorMessage },
  );

  const showFileUpload = () => {
    if (fileUpload) {
      fileUpload.current.click();
      dispatch(showFileUploadAction(false));
    }
  };

  useEffect(() => {
    if (showFile === true) {
      fileUpload.current.click();
      dispatch(showFileUploadAction(false));
    }
  }, [showFile, dispatch]);

  const handleUploadFile = async (e) => {
    const { files } = e.target;
    if (files.length) {
      setIsUploadLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append("upload_files", files[0]);
      const {
        data: { data: filesLinks },
      } = await axios.post(`/api/v1/upload-file`, bodyFormData, {
        headers: {
          Authorization: token,
          "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
        },
      });
      setFile({
        uri: filesLinks[0],
        type:
          filesLinks[0].split(".")[filesLinks[0].split(".").length - 1] === "jpg" ||
          filesLinks[0].split(".")[filesLinks[0].split(".").length - 1] === "jpeg" ||
          filesLinks[0].split(".")[filesLinks[0].split(".").length - 1] === "png",
      });
      setIsUploadLoading(false);
      setFieldValue(field.name, filesLinks[0]);
    }
  };

  const showPreloadImage = () => {
    let comp = null;

    if (errorMessage) {
      comp = <PriorityHigh style={{ fontSize: 36 }} />;
    } else if (file) {
      comp = <img className={classes.avatarThumb} src={imagePreviewUrl} alt="..." />;
    } else if (avatarURL) {
      comp = <img className={classes.avatarThumb} src={avatarURL} alt="..." />;
    } else if (isCreateGroup) {
      comp = <AddGroupAvatar />;
    } else {
      comp = <Person style={{ fontSize: 36, width: "100%", height: "100%" }} />;
    }
    return comp;
  };

  const handleImageChange = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      reader.onloadend = () => {
        setFile(uploadedFile);
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(uploadedFile);
    }
    handleUploadFile(e);
  };

  return (
    <div className={classes.container}>
      <input
        className={classnames(classes.hidden)}
        id="avatar_url"
        name="avatar_url"
        type="file"
        onChange={handleImageChange}
        ref={fileUpload}
        accept=".jpg, .jpeg, .png"
      />

      <Avatar
        className={classnames(avatarStyle, isGroupInfo ? classes.groupInfo : "")}
        ref={imageRef}
        onClick={showFileUpload}
      >
        {!isUploadLoading ? showPreloadImage() : <Loader from />}
      </Avatar>

      {errorMessage ? (
        <Typography variant="caption" color="error">
          {errorMessage}
        </Typography>
      ) : null}
    </div>
  );
};

export default withStyles(customImageInputStyle)(CustomImageInput);
